module.exports = __webpack_public_path__ + "img/menu_icon.c413e9ac.svg";